import { useMutation } from '@tanstack/react-query'

import { signOutUser } from '@/api/mutate'

function useSignOutMutation() {
  return useMutation({ mutationFn: signOutUser() })
}

export default useSignOutMutation
